const userManagement = {
  assignRole: 'Assign Role',
  currentRole: 'Current Role',
  newRole: 'New Role',
  role: 'Role {0}',
  userManagement: 'User Management',
  usersViewed: 'Users viewed {0}',
};

export default userManagement;
